import Vue from 'vue'
import axios from 'axios'
import vueScrollto from 'vue-scrollto'
import VueAxios from 'vue-axios'
import VeeValidate, { Validator } from 'vee-validate'
import VModal from 'vue-js-modal'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

import VueToastr from '@deveodk/vue-toastr'
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'

import uk from 'vee-validate/dist/locale/uk'

import App from './App.vue'
import router from './router'
import store from './store'

const VueInputMask = require('vue-inputmask').default

Vue.use(VueInputMask)

Vue.use(VModal)
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000
})

Vue.directive('filter', (el, binding) => {
  if (binding.arg === 'onlyNumber') {
    el.value = el.value.replace(/[^0-9]+/g, '')
    binding.value = el.value
  }
  if (binding.arg === 'typeKved') {
    el.onkeyup = function () {
      const key = event.keyCode || event.charCode
      if (key !== 8) {
        el.value = el.value.replace(/^(\d{2})$/, el.value + '.')
      }
    }
    binding.value = el.value
  }
})

const dict = {
  custom: {
    inn: {
      length: (field, [length]) => `Це поле повинно містити ${length} цифр`
    },
    sum: {
      between: (field, [min, max]) => `Сума повинна бути не менше ${min} і не більше ${max}`,
      numeric: 'Це поле може містить лише цифри'
    },
    userName: {
      required: 'Введіть ім\'я'
    },
    phoneNumber: {
      required: 'Введіть номер телефону',
      regex: 'Введіть номер телефону'
    },
    otp: {
      length: (field, [length]) => `Це поле повинно містити ${length} цифри`
    },
    supplementRequestKved: {
      required: 'Введіть основний КВЕД',
      regex: 'Введіть основний КВЕД'
    },
    AboutBusinessBusinessDescription: {
      required: 'Заповніть поле'
    },
    AboutBusinessSuppliers: {
      required: 'Заповніть поле'
    },
    AboutBusinessBuyers: {
      required: 'Заповніть поле'
    },
    AboutBusinessPurposeLoan: {
      required: 'Оберіть цільове призначення кредиту'
    },
    addressLegal: {
      required: 'Заповніть адресу'
    }
  }
}
Validator.localize({ uk: uk })
Validator.localize('uk', dict)
Vue.use(VeeValidate, { locale: 'uk', events: 'blur' })
Vue.use(vueScrollto)

Vue.config.productionTip = false

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  tracesSampleRate: 1.0
})

new Vue({
  router,
  store,
  VueAxios,
  axios,
  VueInputMask,
  render: h => h(App)
}).$mount('#app')
